import { StatItem } from '../Models'

export const SEED_STATS: readonly StatItem[] = [
  {
    id: 'credit-financing',
    label: 'Credit financing',
    prefix: '$',
    number: '1.2',
    suffix: 'M',
    description: 'in credit financing disbursed to TradeGrid customers',
    color: 'navy',
    visible: true,
  },
  {
    id: 'active-customers',
    label: 'Active customers',
    prefix: '',
    number: '4,500',
    suffix: '+',
    description: 'active customers growing their businesses with TradeGrid',
    color: 'pink',
    visible: true,
  },
  {
    id: 'energy-supplied',
    label: 'Energy supplied',
    prefix: '',
    number: '1.5',
    suffix: 'MW',
    description: 'MegaWatts of energy supplied, in various locations across Nigeria',
    color: 'ink',
    visible: true,
  },
  {
    id: 'fuel-delivered',
    label: 'Fuel delivered',
    prefix: '',
    number: '240',
    suffix: 'M+',
    description: 'litres of fuel products delivered across Nigeria and Kenya',
    color: 'purple',
    visible: true,
  },
]
